module.exports = __webpack_public_path__ + "static/media/signal-alt-3.04b09f44.svg";